module.exports = __webpack_public_path__ + "img/3bb2e08622a77b8d513c6e8536421730.png";